var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSlack(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC107",
    d: "M15.497 1.47A2.131 2.131 0 0 0 12.813.103a2.125 2.125 0 0 0-1.368 2.68l5.507 16.913a2.132 2.132 0 0 0 2.592 1.319c1.13-.325 1.82-1.523 1.458-2.631-.013-.044-5.505-16.916-5.505-16.916z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4CAF50",
    d: "M7.057 4.371a2.13 2.13 0 0 0-4.05 1.314l5.506 16.913a2.132 2.132 0 0 0 2.591 1.319c1.13-.325 1.82-1.523 1.459-2.631L7.057 4.37z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EC407A",
    d: "M22.53 15.496a2.13 2.13 0 0 0-1.314-4.05L4.303 16.952a2.132 2.132 0 0 0-1.319 2.591c.325 1.13 1.523 1.82 2.631 1.458l16.916-5.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#472A49",
    d: "M7.624 20.308l3.98-1.294-1.294-3.981-3.98 1.294 1.294 3.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#CC2027",
    d: "M16.327 17.407c1.506-.49 2.904-.943 3.98-1.294l-1.293-3.981-3.981 1.294 1.294 3.98z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2196F3",
    d: "M19.63 7.057a2.13 2.13 0 0 0-1.315-4.051L1.402 8.513a2.13 2.13 0 0 0-1.318 2.592c.325 1.13 1.523 1.818 2.631 1.458l16.914-5.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1A937D",
    d: "M4.985 11.868l3.982-1.294-1.294-3.98-3.98 1.293 1.292 3.981z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#65863A",
    d: "M13.426 8.967l3.98-1.294-1.293-3.98-3.981 1.293 1.294 3.981z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlack);
export default __webpack_public_path__ + "static/media/slack.1a1397626c0cfa951ce642ccacc2491f.svg";
export { ForwardRef as ReactComponent };